import React, { useState } from 'react';
import { ExpressionInputConnected, ExpressionInputStyledWrapper } from '../../expressions';
export function ChecklistExpression(props) {
    const [validationResult, setValidationResult] = useState();
    return (React.createElement(ExpressionInputStyledWrapper, { validationResult: props.disabled ? undefined : validationResult },
        React.createElement(ExpressionInputConnected, Object.assign({ validate: true, includeBlockSuggestions: true, includeFactSuggestions: true, onValidate: (result) => {
                setValidationResult(result);
            } }, props))));
}
